

import { NSServerCalls } from './utils/servercalls';

export let NSPageLabels = {}

/**
 * @returns promise
 */
NSPageLabels.init = function()
{
    let o_promise_result = new Promise((resolve, reject) => 
        {
        
            NSPageLabelsPrivate.init( resolve );
        }
    );


    this.f_get_label_by_internal_name =         function () { return NSPageLabelsPrivate.f_get_label_by_internal_name.apply( NSPageLabelsPrivate, arguments ); };
    this.f_get_label_text_by_internal_name =    function () { return NSPageLabelsPrivate.f_get_label_text_by_internal_name.apply( NSPageLabelsPrivate, arguments ); };

    this.objs = {};
    this.objs = NSPageLabelsPrivate.objs.PageLabel;  
  


    window.NSPageLabels_ = NSPageLabels;
    window.NSPageLabelsPrivate_ = NSPageLabelsPrivate;

    
    return o_promise_result;
	
}


let NSPageLabelsPrivate = 
{
    private_objs:
    {
        o_page_labels: {}
    },

    init: function(f_cb_in)
    {
        let this_ = this;

        this.objs.f_init();
        let o_page_labels = this.private_objs.o_page_labels;

        let f_get_page_labels_cb = function(o_resp)
		{
            o_resp.features.forEach( (o_feature_i) => { 
                let s_id = o_feature_i.id;
                let s_internal_name = o_feature_i.properties.internal_name;
                let s_text_value = o_feature_i.properties.text_value;

                let o_page_label = new this_.objs.PageLabel(
                    {
                        id: s_id, 
                        internal_name: s_internal_name, 
                        text_value: s_text_value
                    });

                o_page_labels[s_internal_name] = o_page_label;

            });

            f_cb_in();

				
		};

        let o_data_in = 
        {
            //s_language_internal_name: "pt"    //ex: "pt" || "en", default 'pt'
        };

        NSServerCalls.f_get_page_labels(o_data_in, f_get_page_labels_cb);
		
    },

    /**
     * 
     * @param {string} s_internal_name 
     * 
     * @returns {NSPageLabels.objs.PageLabel}
     */
     f_get_label_by_internal_name: function(s_internal_name)
     {
         let o_page_labels = this.private_objs.o_page_labels;
         return o_page_labels[s_internal_name];
     },
     /**
     * 
     * @param {string} s_internal_name 
     * 
     * @returns {NSPageLabels.objs.PageLabel}
     */
    f_get_label_text_by_internal_name: function(s_internal_name)
    {
        let o_page_labels = this.f_get_label_by_internal_name(s_internal_name);
        let text_value = o_page_labels? o_page_labels.text_value : null;
        return text_value;
    },

    


    objs:
    {
        /**
         * 
         * @param {} o_in  {id, internal_name, text_value}
         * 
         * @property {string} id
         * @property {string} internal_name
         * @property {string} text_value
         */
        PageLabel: function(o_in)
        {
            this.id = o_in.id;
            this.internal_name = o_in.internal_name;
            this.text_value = o_in.text_value;
        },


        f_init: function()
        {

        }
    }

}